<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.9993 20.0007C24.6017 20.0007 28.3327 16.2697 28.3327 11.6673C28.3327 7.06494 24.6017 3.33398 19.9993 3.33398C15.397 3.33398 11.666 7.06494 11.666 11.6673C11.666 16.2697 15.397 20.0007 19.9993 20.0007Z"
      stroke="#F57E53"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M28.3331 23.334H28.9198C30.1382 23.3343 31.3146 23.7796 32.228 24.5861C33.1413 25.3926 33.7287 26.5049 33.8798 27.714L34.5314 32.9207C34.5901 33.3897 34.5482 33.8659 34.4088 34.3175C34.2693 34.7692 34.0354 35.186 33.7225 35.5403C33.4096 35.8946 33.0249 36.1784 32.594 36.3727C32.1631 36.567 31.6958 36.6674 31.2231 36.6673H8.77644C8.30375 36.6674 7.83643 36.567 7.40552 36.3727C6.9746 36.1784 6.58994 35.8946 6.27707 35.5403C5.96419 35.186 5.73025 34.7692 5.59078 34.3175C5.45131 33.8659 5.40949 33.3897 5.46811 32.9207L6.11811 27.714C6.26927 26.5044 6.85714 25.3916 7.77116 24.585C8.68519 23.7784 9.86241 23.3335 11.0814 23.334H11.6664"
      stroke="#F57E53"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
